// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
// First, so the design tokens are on :root as custom properties before anything
// renders. Every other module reaches the same values through the default
// export; this import is here for the CSS side of them.
import './theme';
import './i18n';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Outside <App/> deliberately: a throw inside AuthProvider or the router has to
// be caught too, and those are precisely the ones that used to blank the page.
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
